import { jsx as c } from "react/jsx-runtime";
import l from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as s } from "react";
const m = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 6 20 20", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16 26c5.523 0 10-4.477 10-10S21.523 6 16 6 6 10.477 6 16s4.477 10 10 10m-4.883-9.448 3.1 3.322c.156.168.41.168.566 0l6.1-6.535a.45.45 0 0 0 0-.606l-.566-.607a.38.38 0 0 0-.566 0L14.5 17.75l-2.251-2.412a.38.38 0 0 0-.566 0l-.566.607a.45.45 0 0 0 0 .607", clipRule: "evenodd" })), a = /* @__PURE__ */ s(({ size: e = "inherit", sx: o, ...n }, r) => {
  const i = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ c(l, {
    ...n,
    ref: r,
    component: m,
    inheritViewBox: !0,
    sx: i
  });
});
a.displayName = "svg_success";
export {
  a as default
};
